import { render, staticRenderFns } from "./MchPayPassageAddOrEdit.vue?vue&type=template&id=0c5fdde8&scoped=true"
import script from "./MchPayPassageAddOrEdit.vue?vue&type=script&lang=js"
export * from "./MchPayPassageAddOrEdit.vue?vue&type=script&lang=js"
import style0 from "./MchPayPassageAddOrEdit.vue?vue&type=style&index=0&id=0c5fdde8&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0c5fdde8",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/build/code/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('0c5fdde8')) {
      api.createRecord('0c5fdde8', component.options)
    } else {
      api.reload('0c5fdde8', component.options)
    }
    module.hot.accept("./MchPayPassageAddOrEdit.vue?vue&type=template&id=0c5fdde8&scoped=true", function () {
      api.rerender('0c5fdde8', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/mchApp/MchPayPassageAddOrEdit.vue"
export default component.exports